<template>
  <b-field>
    <p class="control dial_size">
      <b-autocomplete
        v-model="dialCode"
        :data="avCodesFiltered"
        open-on-focus
        field="dial_code"
        :placeholder="$t('dial_code')"
        @select="(option) => (dialCode = option.dial_code)"
      >
        <template slot-scope="props">
          <div class="media">
            <div class="media-content">
              <b>
                {{ props.option.dial_code }}
              </b>
              <br />
              <small>
                <span v-if="typeof props.option.name == 'string'">{{ props.option.name }}</span>
              </small>
            </div>
          </div>
        </template>
      </b-autocomplete>
    </p>
    <b-input
      v-model="phoneNumber"
      type="tel"
      :placeholder="required ? '' : $t('optional')"
      :required="required"
      pattern="[0-9 ]{0,15}"
    />
  </b-field>
</template>

<script>
import isoPhoneCodes from "@/iso-phone-codes";
export default {
  name: "PhoneNumberPicker",
  props: {
    value: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      phoneNumber: "",
      dialCode: "",
    };
  },
  computed: {
    combinedPhoneNumber() {
      if (this.phoneNumber) {
        return this.dialCode + " " + this.phoneNumber.trim();
      }
      return "";
    },
    avCodesFiltered() {
      return isoPhoneCodes.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(this.dialCode.toLowerCase()) >= 0 ||
          (option.dial_code && option.dial_code.toString().toLowerCase().indexOf(this.dialCode.toLowerCase()) >= 0) ||
          (option.code && option.code.toString().toLowerCase().indexOf(this.dialCode.toLowerCase()) >= 0)
        );
      });
    },
  },
  watch: {
    combinedPhoneNumber() {
      this.$emit("input", this.combinedPhoneNumber);
    },
    value: {
      immediate: true,
      handler(value) {
        if (value) {
          this.dialCode = value.split(" ", 1)[0];
          this.phoneNumber = value
            .split(this.dialCode + " ")
            .slice(1)
            .join(" ");
        }
      },
    },
  },
};
</script>

<style scoped>
.dial_size >>> .input {
  max-width: 90px;
}
.dial_size >>> .dropdown-content {
  min-width: 300px;
}
/* Chrome, Safari, Edge, Opera */
.control >>> input::-webkit-outer-spin-button,
.control >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.control >>> input[type="number"] {
  -moz-appearance: textfield;
}
</style>
